import { render, staticRenderFns } from "./LinkDeviationTrainDeviationTable.vue?vue&type=template&id=0abf7b25"
import script from "./LinkDeviationTrainDeviationTable.vue?vue&type=script&lang=js"
export * from "./LinkDeviationTrainDeviationTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports